<template>
  <div
    id="HomeOrders"
    class="orders"
  >
    <el-table
      class="HomeOrders el-table--scrollable-x"
      header-row-class-name="HomeOrders-HeaderRow"
      header-cell-class-name="HomeOrders-HeaderCell"
      cell-class-name="HomeOrders-Cell"
      border
      :data="orders"
      :height="tableHeight"
      :row-class-name="hightLightCancelRow"
      :empty-text="`お探しの注文は見つかりませんでした。`"
      @row-click="onClickDetail"
      @click="false"
    >
      <!-- メッセージ（やり取り） -->
      <el-table-column
        class="column"
        prop="[
          hasUnReadMessage,
          messageCount,
          unreadMessageCount,
        ]"
        label="メッセージ"
        width="99"
      >
        <template slot-scope="scope">
          <!-- メッセージの未読・既読状態で３段階表示にする -->
          <!-- ①: メッセージが無い場合はアイコン・バッジ非表示 -->
          <!-- ②: メッセージがあり、未読を含む場合はアイコンとバッジを表示 -->
          <!-- ③: メッセージがあり、すべて既読の場合はアイコン灰色表示でバッジ非表示 -->
          <el-badge
            :value="scope.row.unreadMessageCount"
            :hidden="!scope.row.hasUnReadMessage"
            class="unread-message-badge"
          >
            <font-awesome-icon
              v-if="scope.row.messageCount"
              :icon="['fal', 'comment-dots']"
              :class="{
                read: !scope.row.hasUnReadMessage,
              }"
              size="2x"
            />
          </el-badge>
        </template>
      </el-table-column>

      <!-- 注文番号 -->
      <el-table-column
        label="注文番号"
        width="125"
      >
        <template #header>
          <OrderSortDropDown
            text="注文番号"
            sortKey="orderNumber"
            :sortParams="sortParams"
            @updateSortDirection="$listeners['updateSortDirection']"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.orderNumber }}
        </template>
      </el-table-column>

      <!-- ステータス -->
      <el-table-column
        prop="status.name"
        label="ステータス"
        width="100"
      />

      <!-- 店舗 -->
      <el-table-column
        prop="clientGroup.name"
        label="店舗"
      />

      <!-- 支店 -->
      <el-table-column
        prop="deliveryDestination.name"
        label="支店"
      />

      <!-- 注文日時 -->
      <el-table-column
        prop label="注文日時"
        width="180"
      >
        <template #header>
          <OrderSortDropDown
            text="注文日時"
            sortKey="orderedAt"
            :sortParams="sortParams"
            @updateSortDirection="$listeners['updateSortDirection']"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.orderedAt | formattedYearDate }}
        </template>
      </el-table-column>

      <!-- お名前 -->
      <el-table-column
        id="customer"
        label="お名前"
        width="180"
      >
        <template slot-scope="scope">
          <div
            slot="reference"
            class="name-wrapper"
          >
            <div
              class="customer-name"
              type="text"
            >
              {{ scope.row.customer.name }}
            </div>
          </div>
        </template>
      </el-table-column>

      <!-- 商品名 -->
      <el-table-column
        class-name="product-name"
        prop="detail.product.name"
        label="商品名"
      />

      <!-- 寸法 -->
      <el-table-column
        prop="detail.productVariation.size"
        label="寸法"
        width="70"
      />

      <!-- 出荷日 -->
      <el-table-column
        label="出荷日"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.status.code === 'CONFIRMED' || scope.row.status.code === 'SHIPPED'">
            {{ scope.row.detail.deliveryDate | formattedYearDate }}
          </template>
        </template>
      </el-table-column>

      <!-- 注文担当者 -->
      <el-table-column
        prop="client.name"
        label="注文担当者"
        width="120"
      />

    </el-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import OrderUsecase from "@/usecases/order.usecase";
import OrderSortDropDown from "@/components/OrderSortDropDown";

const TABLE_HEIGHT = "360px";
const RESIZE_TIMEOUT_DURATION = 0.333 * 1000;

export default {
  name: "HomeOrders",
  components: {
    OrderSortDropDown,
  },
  props: {
    status: String,
    orders: Array,
    sortParams: Object,
  },
  data () {
    return {
      orderUsecase: new OrderUsecase(),
      dialog: false,
      ordersIDS: [],
      userRole: "",
      result: null,
      tableHeight: TABLE_HEIGHT,
      isEmptyOrder: false,
      resizeTimeout: null,
    };
  },
  created () {
    this.userRole = this.$store.state.user.role;
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);

      // Some devices may not be able to properly retrieve table height during initial loading
      setTimeout(() => {
        this.resize();
      }, 500);
    });
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    ...mapState({
      clientGroup: state => state.user.clientsGroup,
      isFilter: state => state.orderForm.filter,
    }),
  },
  watch: {
    isEmptyOrder: function () {
      if (this.isEmptyOrder) {
        var element = document.getElementsByClassName("el-table__empty-block");
        for (var i = 0; i < element.length; i++) {
          element[i].innerHTML = "お探しの注文は見つかりませんでした。";
          element[i].style.color = "#909399";
          element[i].style.height = "10rem";
        }
      }
    },
    status: function () {
      // 承認待ちの選択状態をリセット
      this.ordersIDS = [];
    },
    orders: function () {
      this.onResize();
    },
  },
  methods: {
    /**
     * [setPosition description]
     * @param   {[type]}  value  [value description]
     */
    setPosition (value) {
      const element = document.querySelector(".el-table__body-wrapper");

      if (element) {
        element.scrollTop = value;
      }
    },

    /**
     * [resize description]
     */
    resize () {
      const element = document.querySelector("#HomeOrders");
      if (element) {
        this.tableHeight = element.offsetHeight;
      }
    },

    /**
     * [onResize description]
     */
    onResize () {
      // debounce
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(this.resize, RESIZE_TIMEOUT_DURATION);
    },

    // got to order detail screen
    onClickDetail (row) {
      const { id } = row;
      const { $router } = this;
      const element = document.querySelector(".el-table__body-wrapper");
      const position = element.scrollTop;

      this.$emit("keepHomeState", position);
      this.$store.commit("orderForm/isFiltered", false);
      this.$store.commit("orderForm/setOrderId", id);

      $router.push(`/orders/${id}`);
    },

    // hight light in cancel request status order's row
    hightLightCancelRow (order) {
      // キャンセルのリクエストがある場合
      if (order.row.status.code === "CANCEL_REQUEST") {
        return "cancel-row-style";
      }

      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.orders {
  width: 100%;
  overflow: hidden;
}

::v-deep .HomeOrders {
  width: 100%;

  &-HeaderCell,
  &-Cell {
    text-align: center;
  }

  &-HeaderCell {
    font-size: 0.75rem;
  }

  &-Cell.product-name {
    .cell {
      padding: 0 15% !important;
      text-align: left;
    }
  }
}

::v-deep {
  .el-table__body,
  .el-table__footer,
  .el-table__header {
    table-layout: fixed !important;
    border-collapse: collapse !important;
  }

  .el-table--border {
    border: none;
    border-top: 1px solid $--border-color-lighter;
  }

  // .el-table--scrollable-x .el-table__body-wrapper {
  //   overflow-x: hidden !important;
  // }

  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: white;
  }

  .el-table {
    font-size: 1rem;

    th {
      height: 36px;
      padding: 0;
      background-color: $background-gray-light !important;
    }

    td {
      padding: 0 !important;
    }

    .customer-name {
      text-align: left;
    }

    .name-wrapper {
      padding: 12px 20px;
    }

    .unread-message-badge {
      .read {
        color: $--border-color-lighter;
      }

      // バッジサイズ
      sup {
        top: 11px;
        right: 6px;
      }
    }

    // 回出位牌
    .child-row-style {
      background: $background-purple-lighter;
      font-size: 0.9em;

      &:hover > td {
        background-color: $background-purple-lighter !important;
      }
    }

    // キャンセル
    .cancel-row-style {
      background: $background-cancel;

      &:hover > td {
        background-color: $background-cancel !important;
      }
    }
  }
}
</style>
